<script setup>
</script>

<template>
  <div class="legal-page">
    <div class="container">
      <div class="legal-content">
        <h1 class="page-title">隐私政策</h1>
        
        <section>
          <h2>一、我们如何收集信息</h2>
          <p>在您使用水芯服务过程中，我们可能收集以下信息：</p>
          <ul>
            <li>注册信息（手机号、邮箱、公司名称、联系人信息等）</li>
            <li>设备信息（IP 地址、浏览器类型、操作系统）</li>
            <li>使用行为信息（查询记录、访问日志、操作行为）</li>
          </ul>
        </section>

        <section>
          <h2>二、信息的使用目的</h2>
          <p>我们收集的信息仅用于：</p>
          <ul>
            <li>向您提供平台核心功能</li>
            <li>优化产品体验和服务质量</li>
            <li>保障账号与系统安全</li>
            <li>履行法律法规要求</li>
          </ul>
        </section>

        <section>
          <h2>三、Cookie 与日志技术</h2>
          <p>为保障系统稳定运行，水芯可能使用 Cookie 或日志技术，但不会用于识别您的个人敏感身份。</p>
        </section>

        <section>
          <h2>四、信息存储与保护</h2>
          <p>水芯将采取合理的技术措施和管理制度，防止信息被未经授权访问、泄露、篡改或丢失。</p>
        </section>

        <section>
          <h2>五、信息共享、转让与披露</h2>
          <p>除以下情形外，水芯不会向任何第三方披露您的个人信息：</p>
          <ul>
            <li>获得您的明确授权</li>
            <li>法律法规或司法机关要求</li>
            <li>为维护平台合法权益所必需</li>
          </ul>
        </section>

        <section>
          <h2>六、您的权利</h2>
          <p>您有权依法：</p>
          <ul>
            <li>查询、更正您的个人信息</li>
            <li>申请删除相关数据</li>
            <li>注销您的账号</li>
          </ul>
        </section>

        <section>
          <h2>七、未成年人保护</h2>
          <p>水芯主要面向具备完全民事行为能力的用户，未成年人请勿注册或使用本平台服务。</p>
        </section>

        <section>
          <h2>八、联系我们</h2>
          <p>如您对本隐私政策有任何疑问，可通过水芯平台公示的官方联系方式与我们联系。</p>
        </section>
      </div>
    </div>
  </div>
</template>

<style scoped>
.legal-page {
  padding: 40px 0;
  background-color: #f9f9f9;
  min-height: 80vh;
}

.legal-content {
  background: white;
  padding: 40px 60px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  max-width: 960px;
  margin: 0 auto;
}

.page-title {
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 30px;
  text-align: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

section {
  margin-bottom: 30px;
}

h2 {
  font-size: 18px;
  font-weight: 700;
  color: #333;
  margin-bottom: 15px;
  border-left: 4px solid #005eb8;
  padding-left: 10px;
}

p, li {
  font-size: 15px;
  color: #555;
  line-height: 1.8;
  margin-bottom: 10px;
}

ul {
  padding-left: 20px;
  margin-bottom: 10px;
}

li {
  margin-bottom: 8px;
}
</style>
